<div class="conteudo">
    <section>
        <h1>
          <span class="subtitulo">
            {{ roteiroCrossdocking ? 'Crossdocking' : 'Roteiro'}} - {{ info.roteiro }}
          </span>
          <app-status-roteiro
              [mensagem]="descricaoSituacaoRoteiro"
              [color]="color"
              [caminho]="caminho">
          </app-status-roteiro>
        </h1>
  
        <div class="separador" *ngIf="!roteiroCrossdocking">
            <article class="half">
                <div class="label">Entregas</div>
                <div class="info">{{ info.QtdeEntregas }}</div>
            </article>
            <article class="half">
              <div class="label">Peso bruto</div>
              <div class="info">{{ info.PesoBrutoTotal | number:'1.2-2' }} Kg</div>
            </article>
            <article class="half">
                <div class="label">Cubagem</div>
                <div class="info">{{ info.Cubagem | number:'1.2-2' }} M³ ({{ info.Qtde }} Vol)</div>
            </article>
            <article class="half">
                <div class="label">Prev. saída</div>
                <div class="info">{{ util.converteData(info.PrevisaoSaida) | date: 'dd/MM/yyyy' }} - {{ util.converteData(info.PrevisaoSaida) | date: 'hh:mm' }}</div>
            </article>
            <article class="half">
                <div class="label">Tempo estimado</div>
                <div class="info">
                    {{ tempoEstimado? tempoEstimado + ':00' :   info.TempoEstimado? info.TempoEstimado.split('T')[1].split('.')[0] :0 }}
                </div>
            </article>

            <article class="half">
                <div class="label">Versão do app</div>
                <div class="info">{{ versaoApp }}</div>
            </article>
        </div>
        <h1 *ngIf="!roteiroCrossdocking">
            <span class="subtitulo text-uppercase">
                {{info.veiculo.trim()}}/{{ nomeAbreviado }} - {{info.cod_veiculo}}
            </span>
            <button
                class="btn-editar"
                [ngStyle]="{
                    'cursor': idRoteiroSituacao !== 1 || dados.roteirosLimpo ? 'not-allowed' : 'pointer',
                    'opacity': idRoteiroSituacao !== 1 || dados.roteirosLimpo ? '0.6' : '1'
                }"
                [disabled]="idRoteiroSituacao !== 1 || dados.roteirosLimpo"
                (click)="toggleEdicao()">
                <img src="assets/img/icons/icon-lapis-green.svg" alt="">
                Editar
            </button>
        </h1>
        <div class="separador" *ngIf="!roteiroCrossdocking">
            <article class="half">
                <div class="label">Motorista</div>
                <div class="info">{{ info.nome_motorista }}</div>
            </article>
            <article class="half">
                <div class="label">TEL. Motor.</div>
                <div class="info"><a *ngIf="dddMotorista != null && telefoneMotorista > 1" [href]="'https://api.whatsapp.com/send?phone=' + dddMotorista + telefoneMotorista" target="_blank">{{dddMotorista}} {{telefoneMotorista}}</a></div>
            </article>
            <article  *ngIf="ajudantes == null && nomeAjudante">
                <div class="label">Ajudante 1</div>
                <div class="info">{{ nomeAjudante }}</div>
            </article>

            <article  *ngFor="let ajudante of ajudantes; let i = index" >
                <div class="label">Ajudante {{ i + 1}}</div>
                <div class="info">{{ ajudante.nome }}</div>
            </article>
        </div>
        <h1 *ngIf="!roteiroCrossdocking"> Valores </h1>
        <div *ngIf="!roteiroCrossdocking">
            <article class="half">
                <div class="label">Pedidos</div>
                <div class="info">{{ info.ValorPedido | currency:'BRL':true }}</div>
            </article>
            <article class="half">
                <div class="label">Pedágio</div>
                <div class="info">{{ vlrPedagio | currency:'BRL':true }}</div>
            </article>
            <article class="half">
              <div class="label">Descarga</div>
              <div class="info">{{ custoDescarga | currency:'BRL':true }}</div>
            </article>
              <article class="half">
                  <div class="label">Custo Km</div>
                  <div class="info">{{ custoKm | currency:'BRL':true }}</div>
              </article>
              <article class="half">
                  <div class="label">Custo Ideal</div>
                  <div class="info"> {{ info.ValorPedido * custoIdealPorcentagem / 100 | currency:'BRL':true }} ({{ custoIdealPorcentagem.toFixed(2) }}%)</div>
              </article>
              <article class="half">
                  <div class="label">Custo Total</div>
                  <div class="info">{{ custoTotal | currency:'BRL':true }}</div>
              </article>
        </div>

 

        
    </section>
</div>


<div *ngIf="roteiroCrossdocking">
    <box-info-truck-crossdocking  [dados]="dados" [tempoEstimado]="tempoEstimado" [versaoApp]="versaoApp" (editar)="toggleEdicao()"></box-info-truck-crossdocking>
</div>
  

<div class="modal-confirm" *ngIf="showEdicao">
    <div class="modal-conteudo">
        <div class="header-modal">
            <span class="ms-3 titulo-header">Edição</span>
            <button class="btn-close" (click)="toggleEdicao()">
                <img  src="assets/img/icons/close-white.svg">
            </button>
        </div>
        <div>
            <div class="d-flex" style="padding: 40px 40px 10px 40px;">
                <form [formGroup]="formFiltro">
                    <div style="display: flex; flex-direction: row; gap: 32px;">
                        <mat-form-field style="width: 284px;" appearance="outline">
                            <mat-label>Carro</mat-label>
                            <mat-select [value]="info.veiculo" [disabled]="true">
                              <mat-option [value]="info.veiculo"> {{ info.veiculo  }}</mat-option>

                            </mat-select>
                          </mat-form-field>
                          <mat-form-field style="width: 284px;" appearance="outline">
                            <mat-label>Motorista</mat-label>
                            <mat-select [value]="info.nome_motorista" (selectionChange)="alterarNome($event.value)">
                              <mat-option  *ngFor="let nome of nomesMotoristas" [value]="nome">{{ nome }}</mat-option>

                            </mat-select>
                          </mat-form-field>
                    </div>

                    <div style="display: flex; flex-direction: row; gap: 32px;">
                        <mat-form-field style="width: 284px;" appearance="outline"  *ngFor="let ajudante of ajudantes; let i = index">
                            <mat-label>Ajudante {{ i + 1 }}</mat-label>
                            <mat-select  [value]="ajudante.nome" [disabled]="true">
                              <mat-option [value]="ajudante.nome" > {{ ajudante.nome }} </mat-option>
                            </mat-select>
                          </mat-form-field>
                    </div>

                    <div style="display: flex; flex-direction: row; gap: 32px;">
                      <mat-form-field style="width: 284px;" appearance="outline" >
                        <mat-label>Placa do Veículo </mat-label>
                        <mat-select [value]="info.cod_veiculo" (selectionChange)="alterarPlaca($event.value)">
                          <mat-option *ngFor="let placa of placasVeiculos" [value]="placa">
                            {{ placa }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                    </div>
                </form>
            </div>
            <div class="d-flex justify-content-end me-4 pe-3 mb-4" >
              <button class="btn-cancelar me-3" (click)="toggleEdicao()" >Cancelar</button>
              <app-botao-primario titulo="Salvar" [modoDark]="true" (onPress)="salvaEdicao()" imagemBtn="assets/img/icons/icon-check-white.svg"> </app-botao-primario>
            </div>
        </div>
    </div>
</div>
